(() => {
  'use strict';
  function mount(root) {
    if (root.dataset.impactMounted) return;
    root.dataset.impactMounted = 'true';
    const reduce = window.matchMedia('(prefers-reduced-motion: reduce)');
    const motion = () => root.classList.toggle('ip-motion', !reduce.matches);
    motion();
    reduce.addEventListener?.('change', motion);
    if (!('IntersectionObserver' in window)) return;
    const observer = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        if (!entry.isIntersecting) return;
        if (!reduce.matches) entry.target.classList.add('ip-entered');
        observer.unobserve(entry.target);
      });
    }, {threshold: .08});
    root.querySelectorAll('[data-ip-reveal]').forEach(el => observer.observe(el));
    const sticky = root.querySelector('.ip-sticky');
    const order = root.querySelector('.ip-order');
    const footer = root.querySelector('.ip-footer');
    if (sticky && order) {
      const visible = new Set();
      const visibility = new IntersectionObserver(entries => {
        entries.forEach(entry => entry.isIntersecting ? visible.add(entry.target) : visible.delete(entry.target));
        sticky.classList.toggle('ip-sticky-hidden', visible.size > 0);
        if (visible.size > 0) sticky.setAttribute('inert', '');
        else sticky.removeAttribute('inert');
      }, {threshold: 0});
      visibility.observe(order);
      if (footer) visibility.observe(footer);
    }
  }
  document.querySelectorAll('.chura-lp.variant-impact').forEach(mount);
  document.addEventListener('shopify:section:load', e => e.target.querySelectorAll('.chura-lp.variant-impact').forEach(mount));
})();
